export default __webpack_public_path__ + "static/media/watches10.975e618e.jfif";